import { create } from "zustand";
import { useFetchDailySalesSlice } from "../slices/DailySalesReportSlices/fetchDailySales";
interface DailySalesInterface
  extends ReturnType<typeof useFetchDailySalesSlice> {}

export const DailySalesStore = create<DailySalesInterface>((...a) => ({
  ...useFetchDailySalesSlice(...a),
}));
